import { stateAbstract, actionsAbstract, mutationsAbstract } from '@/store/abstract'

const state = {
  basesCount: null,
  basesDetail: {},
  basesList: [],
  formsCount: null,
  formsDetail: {},
  formsList: [],
  ...stateAbstract
}

export default {
  namespaced: true,
  state,
  actions: actionsAbstract,
  mutations: mutationsAbstract
}
